import React from 'react';
import { motion } from 'framer-motion';
import { Trash2, Calendar, Clock, MapPin, Users } from 'lucide-react';
export interface CartItemType {
  id: string;
  type: 'table' | 'room' | 'event';
  title: string;
  subtitle?: string;
  date: string;
  time?: string;
  location?: string;
  guests?: number;
  price: number;
  image: string;
  deposit?: number;
}
interface CartItemProps {
  item: CartItemType;
  onRemove: (id: string) => void;
}
export function CartItem({
  item,
  onRemove
}: CartItemProps) {
  return <motion.div layout initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    scale: 0.95
  }} className="group relative bg-[#1A2228] border border-white/5 rounded-xl overflow-hidden hover:border-[#DDA247]/30 transition-colors duration-300" data-id="element-101">
      <div className="flex flex-col sm:flex-row" data-id="element-102">
        {/* Image */}
        <div className="sm:w-48 h-48 sm:h-auto relative overflow-hidden" data-id="element-103">
          <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-104" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B1014]/80 to-transparent sm:hidden" data-id="element-105" />
          <div className="absolute top-3 left-3 bg-[#DDA247] text-[#0B1014] text-xs font-bold px-2 py-1 uppercase tracking-wider rounded" data-id="element-106">
            {item.type}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 p-6 flex flex-col justify-between" data-id="element-107">
          <div className="flex justify-between items-start gap-4" data-id="element-108">
            <div data-id="element-109">
              <h3 className="text-xl font-bold text-white uppercase tracking-wide mb-1" data-id="element-110">
                {item.title}
              </h3>
              {item.subtitle && <p className="text-[#DDA247] text-sm font-medium mb-3" data-id="element-111">
                  {item.subtitle}
                </p>}

              <div className="space-y-2 mt-4" data-id="element-112">
                <div className="flex items-center text-gray-400 text-sm" data-id="element-113">
                  <Calendar className="w-4 h-4 mr-2 text-[#DDA247]/70" data-id="element-114" />
                  {item.date}
                </div>
                {item.time && <div className="flex items-center text-gray-400 text-sm" data-id="element-115">
                    <Clock className="w-4 h-4 mr-2 text-[#DDA247]/70" data-id="element-116" />
                    {item.time}
                  </div>}
                {item.location && <div className="flex items-center text-gray-400 text-sm" data-id="element-117">
                    <MapPin className="w-4 h-4 mr-2 text-[#DDA247]/70" data-id="element-118" />
                    {item.location}
                  </div>}
                {item.guests && <div className="flex items-center text-gray-400 text-sm" data-id="element-119">
                    <Users className="w-4 h-4 mr-2 text-[#DDA247]/70" data-id="element-120" />
                    {item.guests} Guests
                  </div>}
              </div>
            </div>

            <button onClick={() => onRemove(item.id)} className="text-gray-500 hover:text-red-400 transition-colors p-2 hover:bg-white/5 rounded-full" aria-label="Remove item" data-id="element-121">
              <Trash2 className="w-5 h-5" data-id="element-122" />
            </button>
          </div>

          <div className="mt-6 pt-4 border-t border-white/5 flex justify-between items-end" data-id="element-123">
            <div data-id="element-124">
              {item.deposit && <p className="text-xs text-gray-500 mb-1" data-id="element-125">
                  Deposit Required: ${item.deposit.toLocaleString()}
                </p>}
            </div>
            <div className="text-right" data-id="element-126">
              <p className="text-2xl font-bold text-white" data-id="element-127">
                ${item.price.toLocaleString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}